var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQlikSense = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2552 18.7383C15.6326 20.0251 13.6216 20.7236 11.5507 20.7196C6.48765 20.7281 2.38177 16.623 2.38177 11.5507C2.38177 9.36913 3.13949 7.3701 4.40544 5.79613L2.7229 4.10588C0.960317 6.18558 -0.00486043 8.82453 1.84061e-05 11.5507C1.84061e-05 17.9305 5.17164 23.1013 11.5507 23.1013C14.3575 23.1013 16.9302 22.1026 18.9293 20.437L17.2552 18.7383Z",
    fill: "#54565A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8182 22.5099H24L20.5687 18.7706C22.2113 16.7231 23.1049 14.1757 23.1014 11.5507C23.1014 5.17162 17.9297 1.83583e-06 11.5507 1.83583e-06C9.86871 -0.000947226 8.20689 0.36609 6.68177 1.07537C5.15666 1.78465 3.80595 2.819 2.7229 4.10588L4.40544 5.79613C5.26454 4.72531 6.35289 3.86161 7.59128 3.26907C8.82966 2.67654 10.1855 2.37037 11.5584 2.37328C16.6299 2.37328 20.735 6.47916 20.735 11.5507C20.735 14.4653 19.3782 17.0642 17.2621 18.7375L18.8369 20.3199L18.9031 20.3946L18.92 20.4116L20.8182 22.5099Z",
    fill: "#009845"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQlikSense);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qlik-sense.f485bc82d510a62e13bfb55ec654d90b.svg";